import axios from 'axios';
import axiosInstance from '../axiosInstance';

export const registerCandidate = (candidateData) => {
  return axiosInstance.post('/user/register/candidate', candidateData);
};
  
export const fetchTotalCandidates = (page = 0, size = 10, search = '') => {
  return axiosInstance.get('/user/total-candidates', {
    params: {
      page,
      size,
      search: search || ''
    },
    withCredentials: true 
  });
};


export const fetchLoginExpiredCandidates = (page, size, search) => {
  return axiosInstance.get('/user/loginExpired/candidates', {
    params: {
      page,
      size,
      search: search || ''
    },
    withCredentials: true 
  });
};

export const fetchBgvInProgressCandidates = (page, size, search) => {
  return axiosInstance.get('/user/inProgress/candidates', {
    params: {
      page,
      size,
      search: search || ''
    },
    withCredentials: true 
  });
};
export const fetchSubmittedCandidates = (page, size, search) => {
  return axiosInstance.get('/user/submit/candidates', {
    params: {
      page,
      size,
      search: search || ''
    },
    withCredentials: true 
  });
};

export const fetchBgvCompletedCandidates = (page, size, search) => {
  return axiosInstance.get('/user/bgvCompleted/candidates', {
    params: {
      page,
      size,
      search: search || ''
    },
    withCredentials: true 
  });
};

export const fetchUserCandidates = (page, size, search) => {
  return axiosInstance.get('/user/pending/candidates', {
    params: {
      page,
      size,
      search: search || ''
    },
    withCredentials: true 
  });
};



export const fetchUserDashboardData = () => {
  return axiosInstance.get('/user/home');
};

export const fetchUserProfile = () => {
  return axiosInstance.get('/user/user/profile');
};

export const updatePhoneNumber = (mobileNo, email) => {
  return axiosInstance.put(`/user/updatePhoneNumber/${mobileNo}/${email}`);
};
export const fetchpendingsubmissionCandidates = (page, size, search) => {
  return axiosInstance.get('/user/nonSubmit/candidates', {
    params: {
      page,
      size,
      search: search || ''
    },
    withCredentials: true 
  });
};

export const startCandidateBGC = (candidateId) => {
  return axiosInstance.post(`/user/start-bgc`, null, {
    params: { candidateId },
  });
};
export const fetchRecentCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/recent?page=${page}&size=${size}`);
};
export const fetchCandidateInfo = (candidateId, page = 0, size = 10) => {
  return axiosInstance.get(`/user/candidateInfo/${candidateId}`);
};

export const restoreCandidate = (candidateId) => {
  return axiosInstance.post(`/user/refresh-candidate/${candidateId}`);
};

export const softDeleteCandidate = (candidateId) => {
  return axiosInstance.put(`/user/soft-delete/${candidateId}`);
};



export const fetchFullCandidateReport = (candidateId) => {
  return axiosInstance.get(`/user/candidate-verification/${candidateId}`);
};

export const downloadReport = async (candidateId) => {
  const response = await axiosInstance.get(`/user/generate/${candidateId}`, {
    responseType: 'blob',
  });
  return response.data;
};
 
export const confirmUserAccount = (token) => {
  return axiosInstance.get(`/user/confirm-account?token=${token}`);
};

export const fetchNotifications = () => {
  return axiosInstance.get('/user/notifications');
};